module.exports = __webpack_public_path__ + "img/山东大学.db8fd23c.png";